import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  header: { id: 'towingRecord.view.signatureButton', defaultMessage: 'Allekirjoitus' },
  signatureTypeWritten: { id: 'signature.type.written', defaultMessage: 'Käsin' },
  signatureTypeOnlineAcceptance: { id: 'signature.type.onlineAcceptance', defaultMessage: 'Sähköpostitse' },
  signatureTypeOnlineAcceptanceSms: { id: 'signature.type.onlineAcceptanceSms', defaultMessage: 'Tekstiviestitse' },
  remindersEnabled: { id: 'signature.reminders.enabled', defaultMessage: 'Lähetä muistutuksia (3 kpl)' },
  remindersDisabled: { id: 'signature.reminders.disabled', defaultMessage: 'Ei muistutusta' },
  errorSignatureRequired: {
    id: 'signature.error.signatureRequired',
    defaultMessage: 'Allekirjoitus ja nimenselvennys ovat pakollisia.',
  },
  errorEmailRequired: { id: 'signature.error.emailRequired', defaultMessage: 'Sähköpostiosoite on pakollinen.' },
  errorInvalidPhone: {
    id: 'signature.error.invalidPhone',
    defaultMessage: 'Puhelinnumero on virheellinen. (+, numerot ja välilyönnit ovat sallittuja)',
  },
  confirmDeleteLabel: { id: 'signature.confirmDelete.label', defaultMessage: 'Vahvista allekirjoituksen poistaminen' },
  confirmDeleteMessage: {
    id: 'signature.confirmDelete.message',
    defaultMessage: 'Haluatko varmasti poistaa allekirjoituksen?',
  },
  confirmDeleteConfirm: { id: 'signature.confirmDelete.confirm', defaultMessage: 'OK' },
  confirmResendLabel: {
    id: 'signature.confirmResend.label',
    defaultMessage: 'Vahvista hyväksyntäpyynnön uudelleenlähetys',
  },
  confirmResendMessage: {
    id: 'signature.confirmResend.message',
    defaultMessage: 'Haluatko varmasti lähettää hyväksyntäpyynnön uudelleen?',
  },
  confirmResendConfirm: { id: 'signature.confirmResend.confirm', defaultMessage: 'Lähetä' },
  cancel: { id: 'signature.cancel', defaultMessage: 'Peruuta' },
  signedAt: { id: 'signature.signedAt', defaultMessage: 'Allekirjoitettu {date} ({name})' },
  pendingAcceptanceEmail: {
    id: 'signature.pendingAcceptanceEmail',
    defaultMessage: 'Odottaa hyväksyntää (Lähetetty: {date} osoitteeseen {email})',
  },
  pendingAcceptancePhone: {
    id: 'signature.pendingAcceptancePhone',
    defaultMessage: 'Odottaa hyväksyntää (Lähetetty: {date} numeroon {phone})',
  },
  resend: { id: 'signature.resend', defaultMessage: 'Lähetä uudelleen' },
  remove: { id: 'signature.remove', defaultMessage: 'Poista' },
  signatorNameLabel: { id: 'signature.signatorName.label', defaultMessage: 'Tilaaja' },
  signatorNamePlaceholder: { id: 'signature.signatorName.placeholder', defaultMessage: 'Nimenselvennys' },
  importSignator: { id: 'signature.importSignator', defaultMessage: 'Tuo tilaaja' },
  clear: { id: 'signature.clear', defaultMessage: 'Tyhjennä' },
  save: { id: 'signature.save', defaultMessage: 'Tallenna' },
  sign: { id: 'signature.sign', defaultMessage: 'Allekirjoita' },
  emailLabel: { id: 'signature.email.label', defaultMessage: 'Sähköposti' },
  phoneLabel: { id: 'signature.phone.label', defaultMessage: 'Puhelinnumero' },
  remindersLabel: { id: 'signature.reminders.label', defaultMessage: 'Muistutukset' },
  sendForAcceptance: { id: 'signature.sendForAcceptance', defaultMessage: 'Lähetä hyväksyttäväksi' },
})
